import Service from './Service';

class VersaoOrigemService extends Service {
    async versaoPJe() {
        let versaoOrigem = await this.getVersaoOrigemApi().versaoOrigem();
        return versaoOrigem.data ? versaoOrigem.data['PJe'] : '';
    }
}

export default VersaoOrigemService;
